import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "color-slider" }
const _hoisted_2 = { class: "slider-value" }
const _hoisted_3 = { class: "slider-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "range",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sliderValue) = $event)),
      min: "0",
      max: "100",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSliderUpdate && _ctx.onSliderUpdate(...args)))
    }, null, 544), [
      [_vModelText, _ctx.sliderValue]
    ]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.sliderValue), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1)
  ]))
}